module.exports = __webpack_public_path__ + "static/media/Carousel Image 3.02a0be01.png";